<template>
    <div class="panel">
        <div class="panel_head fx fx-m_between fx-c_start">
            <el-form :inline="true" :model="form" >
                <el-form-item label="关键词">
                    <el-input v-model="form.keywords" placeholder="关键词"></el-input>
                </el-form-item>
            </el-form>
            <el-button type="primary" @click="edit({})">新增</el-button>
        </div>
        <div class="panel_body">
            <el-table
                :data="tableData"
                stripe
                style="width: 100%">
                <el-table-column
                    prop="name"
                    label="角色名称" >
                </el-table-column>
                <el-table-column
                    label="开放功能" >
                    <template slot-scope="scope">
                        <el-button type="primary" size="small" @click="showFuncList(scope.row)">查看</el-button>
                    </template>
                </el-table-column>
                <el-table-column
                    label="是否开启" >
                    <template slot-scope="scope">
                        <el-switch v-model="scope.row.enable"
                                   @change="modifyEnable(scope.row)"
                                   inactive-color="#ff4949">
                        </el-switch>
                    </template>
                </el-table-column>
                <el-table-column
                    label="操作" >
                    <template slot-scope="scope">
                        <el-link type="primary" @click="edit(scope.row)"
                                 :underline="false" ><i class="iconfont icon-bianji"></i><b>编辑</b></el-link>
                        <el-popconfirm @onConfirm="del(scope.row)"
                            title="确认删除该角色吗？"
                        >
                            <el-link type="danger" slot="reference"
                                     :underline="false" ><i class="iconfont icon-shanchu"></i><b>删除</b></el-link>
                        </el-popconfirm>
                    </template>
                </el-table-column>
            </el-table>
        </div>

        <EditDraw v-if="showEditDraw" @submit="loadData"
                         @close="showEditDraw=false" :item="editItem"></EditDraw>
        <AuthDraw v-if="showAuthView" @close="showAuthView=false" :item="authListItem"></AuthDraw>
    </div>
</template>

<style scoped>

</style>
<style>

</style>

<script>
    import AuthDraw from './RoleAuthDraw';
    import EditDraw from './RoleEditDraw';



    export default {
        components: {
            AuthDraw,
            EditDraw
        },
        props: [
            "attr"
        ],
        data() {
            return {
                editItem: {},
                showEditDraw: false,

                showAuthView: false,
                authListItem: {},
                form: {
                    keywords: "",
                },
                tableData: [],
            }

        },

        watch: {
            "form": {
                handler: function (newValue) {
                    this.loadData();
                },
                deep: true

            }
        },

        methods: {
            showFuncList(item) {
                this.authListItem = {...item};
                this.showAuthView = true;
            },
            edit(item) {
                this.editItem = {...item};
                this.showEditDraw = true;

            },

            del(item) {
                this.$ajaxGet("/role/del/" + item.id, (data) => {
                    this.loadData();
                })
            },
            modifyEnable(item) {
                this.$ajaxGet("/role/toggleEnable/" + item.id + "-" + item.enable);
            },

            loadData() {
                this.$ajaxPost("/role/list", {
                    form: this.form,
                }, (data) => {
                    //分页不能带offset，否则会影响后台计算最新offset
                    this.tableData = data.result;
                    this.showEditDraw = false;
                })
            },

        },

        created() {
            this.loadData();
        }

    }
</script>
